module.exports = __webpack_public_path__ + "img/products.19cc649e.svg";